/* ==========================================================================
   Vetrina 3D — coverflow sui carousel prodotti marcati data-carousel-3d
   --------------------------------------------------------------------------
   theme.min.js inizializza tutti i .bls__swiper con effetto "slide" prima che
   questo file venga eseguito (entrambi sono defer, quindi l'ordine è garantito
   dal loro ordine in scripts-tag.liquid). Qui l'istanza del tema viene sostituita
   con una configurata a coverflow.

   Per tornare indietro si richiama BlsSettingsSwiper.BlsCarousel, la funzione
   del tema: sotto la soglia mobile il carousel ridiventa quello originale
   senza duplicare la configurazione.

   theme.min.js NON viene modificato: al prossimo aggiornamento di Umino
   questo file sopravvive.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE_MAX = 767;
  var SELECTOR = '[data-carousel-3d="true"]';

  function num(root, key, fallback) {
    var v = parseFloat(root.getAttribute('data-c3d-' + key));
    return isNaN(v) ? fallback : v;
  }

  function flag(root, key) {
    return root.getAttribute('data-c3d-' + key) === 'true';
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function wants3d(root) {
    if (!window.Swiper) return false;
    if (window.innerWidth <= MOBILE_MAX && !flag(root, 'mobile')) return false;
    return true;
  }

  function currentIndex(root) {
    return root.swiper ? (root.swiper.realIndex || 0) : 0;
  }

  function destroyExisting(root) {
    if (root.swiper && typeof root.swiper.destroy === 'function') {
      root.swiper.destroy(true, true);
    }
  }

  /* torna al carousel standard del tema */
  function revert(root) {
    if (root.dataset.c3dState !== 'on') return;
    destroyExisting(root);
    root.classList.remove('c3d-on', 'c3d-reflect');
    if (root.parentElement) root.parentElement.classList.remove('c3d-glow');
    root.style.removeProperty('--c3d-scale');
    root.dataset.c3dState = 'off';
    if (window.BlsSettingsSwiper && typeof window.BlsSettingsSwiper.BlsCarousel === 'function') {
      window.BlsSettingsSwiper.BlsCarousel(root);
    }
  }

  function apply(root) {
    if (root.dataset.c3dState === 'on') return;

    var start = currentIndex(root);
    destroyExisting(root);

    var scale = num(root, 'scale', 116) / 100;
    root.style.setProperty('--c3d-scale', String(scale));
    root.classList.add('c3d-on');
    if (flag(root, 'reflect')) root.classList.add('c3d-reflect');
    if (flag(root, 'glow') && root.parentElement) root.parentElement.classList.add('c3d-glow');

    /* autoplay e loop restano governati dalle impostazioni già esistenti
       della sezione, non le duplichiamo nel pannello 3D */
    var autoplayOn = root.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion();
    var delay = num(root, 'autoplay-speed', 3000);

    /* Il loop non è opzionale col coverflow: con centeredSlides e loop disattivato
       la prima scheda resta incollata al bordo, non ha nulla da ruotare alla propria
       sinistra e il carousel sembra bloccato. Viene quindi forzato quando il 3D è
       attivo, ignorando l'impostazione "Infinity" della sezione.

       loopedSlides va dichiarato esplicitamente: con slidesPerView:'auto' Swiper non
       sa da solo quante schede duplicare per chiudere il cerchio. */
    var slideCount = root.querySelectorAll('.swiper-slide').length;

    /* Oltre i 90 gradi una scheda mostra il proprio retro e l'immagine appare
       specchiata. Swiper calcola rotateY = rotate * modifier * l, dove l è la
       distanza dal centro misurata in larghezze-scheda: con rotate 48 e
       intensità 1.3 i 90 gradi vengono superati già a una scheda e mezza dal
       centro, e su schermi larghi, dove se ne vedono otto insieme, le esterne
       arrivano oltre i 180 e si vedono rovesciate.

       coverflowEffect.modifier accetta una funzione al posto di un numero
       (verificato nel bundle Swiper 8.4.4 del tema), quindi la rotazione cresce
       come prima vicino al centro e satura prima di ribaltarsi. Il tetto è
       calcolato sul valore di rotazione scelto nel theme editor, così regge
       qualsiasi taratura. Limita anche translateZ, che vale -depth * |p|. */
    var rotate = num(root, 'rotate', 48);
    var intensity = num(root, 'modifier', 13) / 10;
    var MAX_ANGLE = 74;
    var cap = rotate > 0 ? MAX_ANGLE / rotate : Infinity;

    new window.Swiper(root, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: num(root, 'space', 0),
      loop: true,
      loopedSlides: slideCount,
      grabCursor: true,
      speed: 520,
      watchSlidesProgress: true,
      initialSlide: start,
      autoplay: autoplayOn ? { delay: delay, disableOnInteraction: false } : false,
      coverflowEffect: {
        rotate: rotate,
        stretch: 0,
        depth: num(root, 'depth', 300),
        modifier: function (l) {
          var p = l * intensity;
          return Math.max(-cap, Math.min(cap, p));
        },
        slideShadows: true
      },
      navigation: {
        nextEl: root.querySelector('.swiper-button-next'),
        prevEl: root.querySelector('.swiper-button-prev')
      },
      pagination: {
        clickable: true,
        el: root.querySelector('.swiper-pagination')
      }
    });

    root.dataset.c3dState = 'on';
  }

  function sync(root) {
    if (wants3d(root)) apply(root); else revert(root);
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(sync);
  }

  /* theme.min.js gira per primo (defer, caricato prima): a questo punto le
     istanze del tema esistono già e possono essere sostituite */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  } else {
    syncAll();
  }

  /* solo l'attraversamento della soglia mobile richiede di ricostruire */
  var wasNarrow = window.innerWidth <= MOBILE_MAX;
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var isNarrow = window.innerWidth <= MOBILE_MAX;
      if (isNarrow !== wasNarrow) {
        wasNarrow = isNarrow;
        syncAll();
      }
    }, 200);
  });

  /* editor del tema: il tema re-inizializza la sezione, noi dopo di lui */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target || document;
    scope.querySelectorAll(SELECTOR).forEach(function (root) {
      root.dataset.c3dState = 'off';
    });
    setTimeout(function () { syncAll(scope); }, 0);
  });
})();
